import { useFormat } from "../format";

export const useStoreUtils = () => {
    const { formatCurrency, extractNumber } = useFormat();

    /**
     * Retrieves an Alpine store by name
     * @param {string} name - Name of the store to retrieve
     * @returns {Object|undefined} The Alpine store instance or undefined if not found
     */
    const getStore = (name) => {
        return window.Alpine.store(name);
    };

    /**
     * Creates a currency value object with automatic text formatting
     * @returns {Object} Currency object with value/text getters and setters
     * @property {number} _value - Internal raw numeric value
     * @property {string} _text - Internal formatted text value
     * @property {number} value - Getter/setter for the numeric value
     * @property {string} text - Readonly getter for formatted text
     */
    const createCurrencyValue = () => ({
        _value: 0,
        _text: "",
        get value() {
            return this._value;
        },
        set value(value) {
            this._value = extractNumber(value);
            this._text = getStore("currency").format(this._value);
        },
        get text() {
            return this._text;
        },
    });

    return {
        getStore,
        createCurrencyValue,
    };
};
